import { Zap, Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DialogHeader, DialogTitle } from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';

interface RenewalProgramOverviewStepProps {
  onStart: () => void;
  onLater: () => void;
}

/**
 * Deuxième étape du renouvellement : présente le processus de renouvellement
 * et permet de débuter le formulaire ou de reporter.
 */
export const RenewalProgramOverviewStep = ({
  onStart,
  onLater
}: RenewalProgramOverviewStepProps) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-2xl">{t('form.workspace.renewal.logic.title')}</DialogTitle>
      </DialogHeader>

      <div className="mt-6 space-y-6">
        <p className="text-sm leading-relaxed text-muted-foreground">
          {t('form.workspace.renewal.logic.description1')}
        </p>
        <p className="text-sm leading-relaxed text-muted-foreground">
          {t('form.workspace.renewal.logic.description2')}
        </p>

        <div className="flex justify-center">
          <p className="text-sm font-medium text-foreground">
            {t('form.workspace.renewal.overview.estimated.time')}
          </p>
        </div>

        <div className="flex flex-col gap-3 pt-4">
          <Button
            type="button"
            onClick={onStart}
            className="w-full text-white bg-purple-600 hover:bg-purple-700"
          >
            <Zap className="mr-2 w-4 h-4" />
            {t('form.workspace.renewal.overview.start')}
          </Button>

          <Button type="button" variant="outline" onClick={onLater} className="w-full">
            <Calendar className="mr-2 w-4 h-4" />
            {t('form.workspace.renewal.overview.later')}
          </Button>
        </div>
      </div>
    </>
  );
};
